/**
 * Constantes específicas da tela VehiclesConfig.
 * Não reutilizar em outras telas sem avaliar o contexto.
 */

export const SHOW_LEGACY_REPORTS = false;

export const HIGH_SPEED_OPTIONS = [20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125];

export const HIGH_SPEED_TYPE_OPTIONS = [
  { value: 1, label: "Somente empresa" },
  { value: 2, label: "Via — média" },
  { value: 3, label: "Via — grave" },
  { value: 4, label: "Via — gravíssima" },
  { value: 5, label: "Via — todas (média/grave/gravíssima)" },
  { value: 6, label: "Todos (empresa + via)" },
];

/** IDs dos relatórios exibidos manualmente na seção "Outros Relatórios" */
export const OTHER_REPORT_IDS = [
  "visitsSummaryPdfPeriod",
  "visitsSummaryXlsPeriod",
  "visitsAmountPdfPeriod",
  "visitsAmountXlsPeriod",
  "maintenanceSummaryPdfPeriod",
  "maintenanceSummaryXlsPeriod",
];

/** Itens de relatório gerenciados pelo ReportConfigList */
export const VEHICLE_GROUP_REPORT_ITEMS = [
  {
    id: "positionKmzPeriod",
    nome: "Envio de posicionamento KMZ",
    tipo: "KMZ",
    codeReport: 12,
  },
  {
    id: "positionPdfPeriod",
    nome: "Envio de posicionamento PDF",
    tipo: "PDF",
    codeReport: 11,
  },
  {
    id: "positionXlsPeriod",
    nome: "Envio de posicionamento Excel",
    tipo: "EXCEL",
    codeReport: 10,
  },
  {
    id: "activitySummaryPdfPeriod",
    nome: "Resumo de atividades PDF",
    tipo: "PDF",
    codeReport: 16,
  },
  {
    id: "activitySummaryXlsPeriod",
    nome: "Resumo de atividades Excel",
    tipo: "EXCEL",
    codeReport: 15,
  },
  {
    id: "excerptSummaryPdfPeriod",
    nome: "Resumo de movimentação / trechos PDF",
    tipo: "PDF",
    codeReport: 21,
  },
  {
    id: "excerptSummaryXlsPeriod",
    nome: "Resumo de movimentação / trechos Excel",
    tipo: "EXCEL",
    codeReport: 20,
  },
  {
    id: "visitsSummaryXlsPeriod",
    nome: "Relatório de visitas por veículos XLS",
    tipo: "EXCEL",
    codeReport: 25,
  },
  {
    id: "visitsSummaryPdfPeriod",
    nome: "Relatório de visitas por veículos PDF",
    tipo: "PDF",
    codeReport: 26,
  },
  {
    id: "visitsAmountPdfPeriod",
    nome: "Relatório de veículos por visitas PDF",
    tipo: "PDF",
    codeReport: 31,
  },
  {
    id: "visitsAmountXlsPeriod",
    nome: "Relatório de veículos por visitas XLS",
    tipo: "EXCEL",
    codeReport: 30,
  },
  {
    id: "maintenanceSummaryPdfPeriod",
    nome: "Manutenção PDF",
    tipo: "PDF",
    codeReport: 40,
  },
  {
    id: "maintenanceSummaryXlsPeriod",
    nome: "Manutenção XLS",
    tipo: "EXCEL",
    codeReport: 41,
  },
];

/** Relatórios legados (pré-ReportConfigList). Exibidos apenas se SHOW_LEGACY_REPORTS = true */
export const VEHICLE_GROUP_LEGACY_REPORT_TYPES = [
  {
    key: "pontoDeVista",
    codeReport: 3,
    nome: "Envio de relatório de ponto de visita, controle e passagem",
  },
  {
    key: "areaDeRisco",
    codeReport: 4,
    nome: "Envio de relatório de área de risco",
  },
  {
    key: "cercaEletronica",
    codeReport: 5,
    nome: "Envio de relatório de condução em cerca eletrônica",
  },
];


export const MOVEMENT_REPORT_CODE_PDF   = 21; // Resumo de movimentação / trechos PDF
export const MOVEMENT_REPORT_CODE_EXCEL = 20; // Resumo de movimentação / trechos Excel
